import React from "react";
import { connect } from "react-redux";
import { openContextMenu, closeContextMenu, openModal, closeModal, setModalOptions } from "../../../Redux/actions/ui.js";
import ModelCollection, { SubGroupCollection } from "./ModelCollection.js";
import GridFloorSettings from "./GridFloorSettings.js";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Inventum from "../../../../engine/Inventum";
import { selectPermissionCapabilities } from "../../../utils/permissions.js";

function PanelExpandButton(props) {
  return (
    <div className="PanelExpandButton">
      <i className="material-icons notranslate">{props.panelOpen ? "keyboard_arrow_down" : "keyboard_arrow_right"}</i>
    </div>
  );
}

class PanelTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: props.name };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleChange(e) {
    this.setState({ name: e.target.value });
  }

  handleSave() {
    Inventum.models.setGroupName(this.props.panelID, this.state.name);
    this.props.cancelEditing();
  }

  componentDidUpdate(prevProps) {
    if (this.props.editing === true && prevProps.editing === false) {
      this.inputBox.focus();
      this.inputBox.select();
    }
  }

  render() {
    let handleKey = (e) => {
      if (e.key === "Enter") {
        this.handleSave();
      }
    };
    if (this.props.editing) {
      return (
        <div
          className="PanelTitle Editing"
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <input
            onKeyDown={handleKey}
            ref={(input) => {
              this.inputBox = input;
            }}
            value={this.state.name}
            onChange={this.handleChange}
          />
          <div className="PanelTitleEditButton" onClick={this.handleSave}>
            Save
          </div>
          <div
            className="PanelTitleEditButton"
            onClick={() => {
              this.setState({ name: this.props.name });
              this.props.cancelEditing();
            }}>
            Cancel
          </div>
        </div>
      );
    }

    return <div className="PanelTitle">{this.props.name}</div>;
  }
}

function HeaderControls(props) {
  let click = (e) => {
    e.stopPropagation();
    props.visibility.handler(props.contentID);
  };
  let statusIcon;
  switch (props.visibility.status) {
    case "all":
      statusIcon = "check_box";
      break;
    case "none":
      statusIcon = "check_box_outline_blank";
      break;
    case "mixed":
      statusIcon = "indeterminate_check_box";
      break;
    default:
      statusIcon = "check_box_outline_blank";
      break;
  }
  return (
    <div className="HeaderControls" onClick={click}>
      <i className="material-icons notranslate">{statusIcon}</i>
    </div>
  );
}

function SideBarPanelContextMenu(props) {
  let handleRename = (e) => {
    if (!props.siteAdmin) {
      return;
    }
    e.stopPropagation();
    props.closeMenu();
    props.setEditing();
  };

  let handleDelete = (e) => {
    if (!props.siteAdmin) {
      return;
    }
    e.stopPropagation();
    if (window.confirm("Delete Group?")) {
      Inventum.models.deleteGroup(props.panelID);
    }
    props.closeMenu();
  };

  let handleAdd = (e) => {
    if (!props.canAddPasteModels) {
      return;
    }
    props.openModal("InventumAssetManager");
    props.setModalOptions({ type: "mesh", referenceID: props.panelID });
    e.stopPropagation();
    props.closeMenu();
  };

  let handlePaste = (e) => {
    if (!props.canAddPasteModels) {
      return;
    }
    e.stopPropagation();
    props.closeMenu();
    Inventum.models.pasteModel(props.panelID);
  };

  let handleAddSubGroup = (e) => {
    if (!props.siteAdmin) {
      return;
    }
    e.stopPropagation();
    props.closeMenu();
    Inventum.models.createSubGroup(props.panelID);
  };

  const handleDisabledEntryClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const addPasteClassName = `SideBarContextMenuEntry${props.canAddPasteModels ? "" : " MenuEntryDisabled"}`;

  if (props.pageMode !== "3D") {
    return null;
  }
  if (!props.siteAdmin || !props.editMode) {
    return <div className="SideBarPanelContextMenu" />;
  }

  return (
    <div className="SideBarPanelContextMenu">
      <div className="SideBarContextMenuEntry" onClick={handleRename}>
        Rename Group
      </div>
      <div className="SideBarContextMenuEntry MenuEntryWarning" onClick={handleDelete}>
        Delete Group
      </div>
      <div className="SideBarContextMenuEntry" onClick={handleAddSubGroup}>
        Add Sub-group
      </div>
      <div
        className={addPasteClassName}
        onClick={props.canAddPasteModels ? handleAdd : handleDisabledEntryClick}
        aria-disabled={!props.canAddPasteModels}
        title={props.canAddPasteModels ? undefined : "Site admins only"}>
        Add Model
      </div>
      <div
        className={addPasteClassName}
        onClick={props.canAddPasteModels ? handlePaste : handleDisabledEntryClick}
        aria-disabled={!props.canAddPasteModels}
        title={props.canAddPasteModels ? undefined : "Site admins only"}>
        Paste Model
      </div>
    </div>
  );
}

function DragHandle() {
  return (
    <div className="DragHandle">
      <i className="material-icons notranslate">drag_indicator</i>
    </div>
  );
}

class SideBarPanelHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editingName: false };
    this.handleContext = this.handleContext.bind(this);
    this.handleHeaderClick = this.handleHeaderClick.bind(this);
  }

  handleContext(force) {
    if (this.props.pageMode === "3D" && !this.props.editMode) {
      return;
    }
    if (typeof force === "boolean") {
      if (force) {
        this.props.openContextMenu(this.props.panelID);
      } else {
        this.props.closeContextMenu();
      }
      return;
    }
    if (this.props.panelID === this.props.activeContextMenu) {
      this.props.closeContextMenu();
    } else {
      this.props.openContextMenu(this.props.panelID);
    }
  }

  handleHeaderClick() {
    this.handleContext(false);
    this.props.click();
  }

  render() {
    let contextMenuOpen = this.props.panelID === this.props.activeContextMenu;
    let showHandle = false;

    if (this.props.pageMode === "2D") {
      showHandle = true;
    }

    if (this.props.siteAdmin && this.props.editMode) {
      showHandle = true;
    }
    return (
      <div
        className={"SideBarPanelHeader" + (contextMenuOpen ? " contextOpen" : "")}
        onClick={this.handleHeaderClick}
        onContextMenu={(e) => {
          e.preventDefault();
          this.handleContext(true);
        }}>
        {contextMenuOpen ? (
          <SideBarPanelContextMenu
            setModalOptions={this.props.setModalOptions}
            openModal={this.props.openModal}
            pageMode={this.props.pageMode}
            siteAdmin={this.props.siteAdmin}
            editMode={this.props.editMode}
            canAddPasteModels={this.props.canAddPasteModels}
            panelID={this.props.panelID}
            closeMenu={() => {
              this.handleContext(false);
            }}
            setEditing={() => {
              this.setState({ editingName: true });
            }}
          />
        ) : null}
        {showHandle && this.props.dragHandleProps ? (
          <div {...this.props.dragHandleProps}>
            <DragHandle />
          </div>
        ) : null}
        <HeaderControls visibility={this.props.visibility} contentID={this.props.contentID} />
        {this.props.expandable ? <PanelExpandButton panelOpen={this.props.panelOpen} /> : null}
        <PanelTitle
          panelID={this.props.panelID}
          name={this.props.name}
          editing={this.state.editingName}
          cancelEditing={() => {
            this.setState({ editingName: false });
          }}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  const caps = selectPermissionCapabilities(state);

  return {
    // Legacy prop name retained for compatibility; capability-based source.
    siteAdmin: caps.canAccessEditorUI,
    canAddPasteModels: caps.canAddPasteModels,
    activeContextMenu: state.ui.activeContextMenu,
    pageMode: state.sidebarUI.mode,
    editMode: state.ui.editMode,
  };
};

let mapDispatchToProps = (dispatch) => ({
  openContextMenu: (panelID) => {
    dispatch(openContextMenu(panelID));
  },
  closeContextMenu: () => {
    dispatch(closeContextMenu());
  },
  openModal: (value) => {
    dispatch(openModal(value));
  },
  setModalOptions: (options) => {
    dispatch(setModalOptions(options));
  },
  closeModal: () => {
    dispatch(closeModal());
  },
});

let SideBarPanelHeaderWrapper = connect(mapStateToProps, mapDispatchToProps)(SideBarPanelHeader);

function SideBarPanelBody(props) {
  let handleModelSort = (data) => {
    Inventum.models.sortModels(props.panelID, data);
  };

  let handleSubGroupSort = (data) => {
    Inventum.models.sortSubGroups(props.panelID, data);
  };

  switch (props.type) {
    case "3D_GROUP":
      const hasDirectModels = props.items && props.items.length > 0;
      const hasSubGroups = props.subGroups && props.subGroups.length > 0;
      
      return (
        <div className="SideBarPanelBody">
          {hasSubGroups ? (
            <SubGroupCollection
              parentId={props.panelID}
              subGroups={props.subGroups}
              onSortEnd={handleSubGroupSort}
              openModal={props.openModal}
              setModalOptions={props.setModalOptions}
            />
          ) : null}
          {hasDirectModels ? (
            <ModelCollection collectionId={props.panelID} onSortEnd={handleModelSort} items={props.items} reviewMode={props.reviewMode} />
          ) : null}
        </div>
      );
    case "MAP_LAYER":
      return (
        <div className="SideBarPanelBody">
          <MapLayerOpacity opacity={props.opacity} />
        </div>
      );
    case "WORLD_GRID":
      return (
        <div className="SideBarPanelBody GridFloorPanelBody">
          <GridFloorSettings />
        </div>
      );
    default:
      console.warn("Unsupported Item Type");
      return null;
  }
}

function MapLayerOpacity(props) {
  let style = { display: "flex" };
  let numberBoxStyle = {
    paddingLeft: "5px",
    paddingRight: "5px",
    color: "#FFF",
    fontFamily: "Sans-Serif",
  };
  const opacityValue = props.opacity.value * 100;
  return (
    <div style={style}>
      <div style={numberBoxStyle}>Opacity</div>
      <input
        className="slider"
        style={{ width: "100%", marginLeft: "10px" }}
        type="range"
        min="0"
        max="100"
        onChange={(e) => {
          props.opacity.handler(e.target.value / 100);
        }}
        value={opacityValue}
      />
      <div style={numberBoxStyle}>{parseInt(opacityValue)}</div>
    </div>
  );
}

function SideBarPanelInner(props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
    disabled: props.disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? "none" : transition,
    zIndex: isDragging ? 1000 : 1,
    position: isDragging ? "relative" : undefined,
  };

  const [panelOpen, setPanelOpen] = React.useState(false);

  const content = props.content;
  const expandable = content?.nestedSettings === true || content?.expandable !== false;

  const handleClick = () => {
    if (!expandable) {
      return;
    }
    setPanelOpen(!panelOpen);
  };
  
  // Guard against undefined content
  if (!content) {
    return null;
  }
  
  const items = content.items || [];
  const subGroups = content.subGroups || [];
  const type = content.type;
  const visibility = { status: content.visibility, handler: content.visibilityHandler };
  const opacity = { value: content.opacity, handler: content.opacityHandler };
  const name = content.name;
  const id = content.id;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={"SideBarPanel" + (panelOpen ? " open" : "") + (isDragging ? " dragging" : "")}>
      <SideBarPanelHeaderWrapper
        contentID={id}
        panelID={id}
        visibility={visibility}
        panelOpen={panelOpen}
        name={name}
        click={handleClick}
        expandable={expandable}
        dragHandleProps={content.sortable === false ? null : listeners}
      />
      {expandable && panelOpen && !isDragging ? (
        <SideBarPanelBody
          opacity={opacity}
          items={items}
          subGroups={subGroups}
          type={type}
          panelID={id}
          openModal={props.openModal}
          setModalOptions={props.setModalOptions}
        />
      ) : null}
    </div>
  );
}

let panelMapDispatchToProps = (dispatch) => ({
  openModal: (value) => {
    dispatch(openModal(value));
  },
  setModalOptions: (options) => {
    dispatch(setModalOptions(options));
  },
});

let SideBarPanel = connect(null, panelMapDispatchToProps)(SideBarPanelInner);

export default SideBarPanel;
